module.exports = __webpack_public_path__ + "static/media/duplicate.eaa6fc70.svg";